import {
    getCurrentSuiteId,
    getSiteRouter,
    getUrlByValidate,
    getUrlParameter,
    includes,
    insertURLQuery,
    isEmpty,
    redirect
} from '~/utils';
import { SITE_ROUTER, SuiteId, URL_PARAMETER } from '~/constants';

export const handleRedirect = (suiteId?: SuiteId) => {
    const currentSuiteId = suiteId ?? getCurrentSuiteId();
    const url = insertURLQuery(getSiteRouter(SITE_ROUTER.AUTHENTICATION.SIGNIN_LAUNCH), [
        {
            key: URL_PARAMETER.SUITE_ID,
            value: currentSuiteId
        }
    ]);
    const redirect_uri = window.jdy_redirect_uri || getUrlParameter(URL_PARAMETER.REDIRECT_URI);
    const redirectUrl = isEmpty(redirect_uri) ? url : getUrlByValidate(redirect_uri);
    redirect(redirectUrl);
};

/**
 * 判断在【了解渠道】处点选的标签是否为【其他】/【Others】
 *
 * @param tagValue 当前点选的标签键值
 */
export const isOtherTag = (tagValue: string) => {
    return includes(['others', 'jodoo_others', 'analytics_others'], tagValue);
};
